import { Injectable, Type, ComponentFactoryResolver } from '@angular/core';
import { Router } from "@angular/router";
import { AuthenticationService } from "./authentication.service";
import _moment from 'proxies/dayjs';
import { BaseService } from './base.service';
const moment = _moment;

@Injectable({
    providedIn: 'root'
})
export class RuleEngineService {
    config: any = {};

    constructor(
        public router: Router,
        public authenticationService: AuthenticationService,
        public baseService: BaseService,
    ) {

    }


    getPermission(resource: any) {
        var actionAr = ["add", "print", "download"];
        var config: any = {};
        let allPromiseObj: any = [];
        for (let index = 0; index < actionAr.length; index++) {
            let action = actionAr[index];
            allPromiseObj.push(this.getSinglePermission(resource, action));
        }
        return new Promise((resolve, reject) => {
            Promise.all(allPromiseObj).then((response) => {
                for (let index = 0; index < actionAr.length; index++) {
                    let action = actionAr[index];
                    config[action] = response[index];
                }
                resolve(config);
            });
        });
    }

    getSinglePermission(resource: any, action) {
        return new Promise((resolve, reject) => {
            if (resource && resource.config != undefined && resource.config.rule_engine != undefined && resource.config.rule_engine[action] != undefined) {
                let datasource;
                if (resource.config.rule_engine[action].datasource == undefined) {
                    datasource = this.getDefaultDatasource(resource);
                } else {
                    datasource = resource.config.rule_engine[action].datasource;
                }
                var data = { action: action };
                datasource = JSON.parse(JSON.stringify(datasource));
                datasource.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: data }) : '';
                datasource.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: data }) : '';


                this.baseService.getByDataSource(datasource).subscribe(
                    (data: any) => {
                        if (data.errCode == -1) {
                            resolve(true);
                        } else {
                            if (data.resource != undefined && data.resource.length > 0) {
                                //resolve(false);
                                var item = data.resource[0];
                                if (item.allowed != undefined) {
                                    resolve(item.allowed);
                                } else {
                                    resolve(true);
                                }
                            } else {
                                resolve(true);
                            }
                        }
                    });
            } else {
                resolve(true);
            }
        });
    }

    getDefaultDatasource(resource) {
        return {
            "application": "system-management",
            "resource": "valueset",
            "query_id": "get_rule"
        }
    }

    setRuleArgs(rule) {
        this.config['ruleInfo'] = rule;
    }

    reSetFilter(val) {
        this.config['resetFilter'] = val;
    }

}